// État du formulaire de réglages et ce qui en part au serveur (fonctions pures, testées).
import type { Reglages } from '../lib/api';
import { aujourdhuiCivil } from '../lib/format';

export interface Formulaire extends Reglages {
  modeDebut: 'date' | 'rang';
  rang: number;
  nom: string;
}

export type Maj = (p: Partial<Formulaire>) => void;

export function initial(r: Reglages, nom: string, maintenant = new Date()): Formulaire {
  return {
    ...r,
    modeDebut: r.debutPlaquette ? 'date' : 'rang',
    debutPlaquette: r.debutPlaquette ?? aujourdhuiCivil(r.fuseau, maintenant),
    rang: 1,
    nom,
  };
}

/** Ce qui part au serveur, champ par champ : jamais le nom de la pilule (05, « Données »). */
export function versServeur(f: Formulaire, fuseau: string) {
  const debut =
    f.modeDebut === 'rang'
      ? { rangAujourdhui: f.rang }
      : { debutPlaquette: f.debutPlaquette ?? '' };
  return {
    heure: f.heure,
    fuseau,
    schema: f.schema,
    inactifs: f.inactifs,
    famille: f.famille,
    relanceMinutes: f.relanceMinutes,
    alerteMinutes: f.alerteMinutes,
    ackDelaiMinutes: f.ackDelaiMinutes,
    fenetreSansFamilleH: f.fenetreSansFamilleH,
    prevenirProche: f.prevenirProche,
    texteNotification: f.texteNotification,
    ...debut,
  };
}
